import React from 'react';
import { benefits, bonuses } from '../data/content';
export function BonusSection() {
  return <>
      <section className="bg-brand-light px-4 py-6 sm:px-6" aria-labelledby="bonus-heading" data-id="element-15" data-mp="1ogn81qbidt6h">
        <div className="mb-3 text-center" data-id="element-16" data-mp="22fwpetbgatc1">
          <h2 id="bonus-heading" className="mb-1 text-2xl leading-none text-brand-ink sm:text-4xl" data-id="element-17" data-mp="22etwygyhciu0">
            🎁 5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-18" data-mp="1annw1yaxqh3o">
            You'll also receive five premium bonuses designed to help you save even more planning
            time, improve athlete performance, and deliver an even more professional coaching
            experience.
          </p>
        </div>
        <div className="space-y-2" data-id="element-19" data-mp="1ep93330sg15y">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="rounded-xl border border-brand-gold/60 bg-white p-3 text-center shadow-sm" data-id="element-20" data-mp="qzohsdh5wrti" data-mpi={index}>
              <p className="mb-0.5 font-heading text-[10px] font-semibold uppercase tracking-wide text-brand-gold" data-id="element-21" data-mp="29s30j90wnf8j">
                🎁 Bonus {index + 1}
              </p>
              <h3 className="mb-0.5 font-heading text-xs font-semibold leading-tight text-brand-ink sm:text-sm" data-id="element-22" data-mp="2epd2fo5hdjd9">
                {bonus.title}
              </h3>
              <p className="text-[11px] leading-snug text-brand-muted sm:text-xs" data-id="element-23" data-mp="2ofxv6uyh3to9">
                {bonus.description}
              </p>
            </article>)}
        </div>
      </section>
      <section className="bg-white px-4 py-6 sm:px-6" aria-labelledby="change-heading" data-id="element-24" data-mp="1vrilmny423kb">
        <h2 id="change-heading" className="mb-3 text-center text-2xl leading-none text-brand-ink sm:text-4xl" data-id="element-25" data-mp="20qvdjn3ua0tr">
          WHAT WILL CHANGE
        </h2>
        <div className="space-y-2" data-id="element-26" data-mp="3c6tv6fd31v6l">
          {benefits.map(benefit => <article key={benefit.title} className="flex gap-2.5 rounded-xl border-l-4 border-brand-red bg-brand-light p-3 shadow-sm" data-id="element-27" data-mp="3c8o8p8m0yl0n">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-28" data-mp="1h1u6bv6i7i5o">
                {benefit.emoji}
              </span>
              <div data-id="element-29" data-mp="1c6okewd3q3hl">
                <h3 className="mb-0.5 font-heading text-xs font-semibold leading-tight text-brand-ink sm:text-sm" data-id="element-30" data-mp="1q3tncnhiqm8m">
                  {benefit.title}
                </h3>
                <p className="text-[11px] leading-snug text-brand-muted sm:text-xs" data-id="element-31" data-mp="1m0drhtd9wpwz">
                  {benefit.description}
                </p>
              </div>
            </article>)}
        </div>
      </section>
    </>;
}